<template>
  <div class="title-sub">{{ content }}</div>
</template>

<script>
 export default {
   name: 'TitleSub',
   props: {
     content: {
       type: String,
       default: ''
     }
   }
 }
</script>

<style lang='scss' scoped>
.title-sub {
  width: 180px;
  height: 70px;
  background: linear-gradient(135deg, transparent 15px, #026ab3 0) top left,
    linear-gradient(-135deg, transparent 15px, #026ab3 0) top right,
    linear-gradient(45deg, transparent 15px, #026ab3 0) bottom left,
    linear-gradient(-45deg, transparent 15px, #026ab3 0) bottom right;
  filter: drop-shadow(0px 0px 10px #026ab3);
  background-size: 50% 50%;
  background-repeat: no-repeat;
  text-align: center;
  font-size: 26px;
  line-height: 70px;
  font-weight: bold;
  color: #afdefa;
}
</style>
